// https://parceljs.org/features/dependency-resolution/#glob-specifiers
export var asyncLanguages = {
  de: function de() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-de" */'../../../i18n/de');
  },
  'en-GB': function enGB() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-en_GB" */'../../../i18n/en_GB');
  },
  'en-ZZ': function enZZ() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-en_ZZ" */'../../../i18n/en_ZZ');
  },
  en: function en() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-en" */'../../../i18n/en');
  },
  es: function es() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-es" */'../../../i18n/es');
  },
  fr: function fr() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-fr" */'../../../i18n/fr');
  },
  it: function it() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-it" */'../../../i18n/it');
  },
  ja: function ja() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-ja" */'../../../i18n/ja');
  },
  ko: function ko() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-ko" */'../../../i18n/ko');
  },
  nl: function nl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-nl" */'../../../i18n/nl');
  },
  pl: function pl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-pl" */'../../../i18n/pl');
  },
  'pt-BR': function ptBR() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-pt_BR" */'../../../i18n/pt_BR');
  },
  ru: function ru() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-ru" */'../../../i18n/ru');
  },
  zh: function zh() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/commerce-credit-card-base-i18n-zh" */'../../../i18n/zh');
  }
};